export default "__VITE_ASSET__C0g_WUwU__"